import type { ZapierFieldsFE } from '../../types';

const getDuplicateKeys = (fields: ZapierFieldsFE): Array<string> => {
  const keys = fields.map(field => field.key);

  return keys.filter((key, index) => keys.indexOf(key) != index);
};

export default getDuplicateKeys;
